const DEFAULT_PAYMENT_METHODS = [
  { id: 'default-cash', name: 'Cash', slug: 'cash', is_active: true, is_default: true },
  { id: 'default-cheque', name: 'Cheque', slug: 'cheque', is_active: true, is_default: false },
  { id: 'default-bank-transfer', name: 'Bank Transfer', slug: 'bank_transfer', is_active: true, is_default: false }
]

export const getDefaultPaymentMethods = () => (
  DEFAULT_PAYMENT_METHODS.map(method => ({ ...method }))
)

export const getPaymentMethodIcon = (method = '') => {
  const value = String(method).toLowerCase().replace(/[\s-]+/g, '_')

  if (value.includes('cash') || value.includes('espèce') || value.includes('espece')) return 'bi-cash-stack'
  if (value.includes('cheque') || value.includes('check')) return 'bi-journal-check'
  if (value.includes('bank') || value.includes('transfer') || value.includes('virement')) return 'bi-bank'
  if (value.includes('card') || value.includes('carte')) return 'bi-credit-card-2-front'
  if (value.includes('mobile') || value.includes('phone')) return 'bi-phone'

  return 'bi-wallet2'
}
